export function buildFullMetabaseUrl(baseUrl: string, parameters?: string) {
    const paramString = parameters ? `?${parameters}` : ''
    return `${baseUrl}${paramString}`
}
